//import type { Level } from "@shared";
// Called for every token amount rendered, so the result is cached per locale
// rather than building an `Intl.NumberFormat` on each call.
const decimalSeparators = {};
export function getDecimalSeparator(locale) {
    if (!locale) {
        return defaultDecimalSeparator;
    }
    let separator = decimalSeparators[locale];
    if (separator === undefined) {
        const numberWithDecimalSeparator = 1.1;
        separator =
            Intl.NumberFormat(locale)
                .formatToParts(numberWithDecimalSeparator)
                .find((part) => part.type === "decimal")?.value ?? defaultDecimalSeparator;
        decimalSeparators[locale] = separator;
    }
    return separator;
}
const defaultDecimalSeparator = ".";
// export type InterpolationValues =
//     | Record<string, string | number | boolean | Date | null | undefined>
//     | undefined;
// interface MessageObject {
//     locale?: string;
//     format?: string;
//     default?: string;
//     values?: InterpolationValues;
// }
// export type MessageFormatter = (id: string, options?: MessageObject) => string;
// export type ResourceKey = {
//     kind: "resource_key";
//     key: string;
//     level?: Level;
//     lowercase: boolean;
//     params?: InterpolationValues;
// };
